import axios from "axios";
import { getCookie } from "../../utils";
import { API_BASE_PATH } from "../../const";


const getSuperadminData = (args) => {
    let query="?"
    if(args.startDate) {
        query += `startDate=${args.startDate}&`
    }
    if(args.endDate) {
        query += `endDate=${args.endDate}&`
    }

    return axios
        .get(API_BASE_PATH + `superadmin/${query}`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};


const SuperadminService = {
    getSuperadminData,
};

export default SuperadminService;